import { render, staticRenderFns } from "./PigDetail.vue?vue&type=template&id=318a01f0&scoped=true"
import script from "./PigDetail.vue?vue&type=script&lang=js"
export * from "./PigDetail.vue?vue&type=script&lang=js"
import style0 from "./PigDetail.vue?vue&type=style&index=0&id=318a01f0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "318a01f0",
  null
  
)

export default component.exports